import React from "react";
import { ArrowUpRight, Sparkles, Zap } from "lucide-react";

const FORM_URL = "https://forms.gle/G2o5HCoARkzxhtrh8";

export default function FormBanner() {
  return (
    <section
      id="analise-rapida"
      data-testid="form-banner-section"
      className="relative overflow-hidden"
    >
      {/* Gold thin edges */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent" />

      {/* Background layers */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at 30% 40%, rgba(212,175,55,0.28) 0%, transparent 55%), radial-gradient(ellipse at 80% 70%, rgba(20,40,90,0.55) 0%, transparent 60%), linear-gradient(135deg, #05070D 0%, #0A1024 55%, #05070D 100%)",
        }}
      />

      {/* Decorative gold rings */}
      <div
        className="absolute -top-40 -left-40 w-[500px] h-[500px] rounded-full border border-[#D4AF37]/10 pointer-events-none"
        aria-hidden
      />
      <div
        className="absolute -bottom-32 -right-32 w-[420px] h-[420px] rounded-full border border-[#D4AF37]/8 pointer-events-none"
        aria-hidden
      />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
          {/* Left — copy */}
          <div className="lg:col-span-8">
            <div className="inline-flex items-center gap-3 mb-7 pl-4 pr-5 py-2 border border-[#D4AF37]/60 bg-[#D4AF37]/[0.08] backdrop-blur-sm">
              <Sparkles size={14} strokeWidth={1.5} className="text-[#D4AF37]" />
              <span className="text-[10px] tracking-[0.3em] uppercase text-[#D4AF37] font-medium">
                Análise Estratégica Gratuita
              </span>
            </div>

            <h2 className="font-serif-ag text-white text-4xl md:text-5xl lg:text-[3.75rem] xl:text-[4.2rem] font-light leading-[1.02] tracking-[-0.02em]">
              Pare de perder{" "}
              <span className="text-[#D4AF37] italic">negócios</span> por falta
              de capital —
              <br className="hidden md:block" />
              tenha crédito{" "}
              <span className="relative inline-block">
                <span className="relative z-10 text-[#F0CC59] italic">ágil e estratégico</span>
                <span
                  className="absolute left-0 right-0 bottom-1 h-2 bg-[#D4AF37]/25 -z-0"
                  aria-hidden
                />
              </span>{" "}
              ao seu lado.
            </h2>

            <p className="mt-6 text-[#D6DBE2] text-base md:text-lg font-light leading-relaxed max-w-2xl">
              Preencha a análise rápida e receba uma proposta sob medida.
              Sem compromisso, sem burocracia — apenas números que fazem
              sentido para o seu momento.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-6">
              <a
                href={FORM_URL}
                target="_blank"
                rel="noreferrer"
                data-testid="form-banner-cta"
                className="group relative inline-flex items-center gap-3 bg-[#D4AF37] text-[#05070D] px-9 py-5 text-xs md:text-sm tracking-[0.22em] uppercase font-semibold hover:bg-[#F0CC59] transition-all duration-300 shadow-[0_0_0_1px_rgba(212,175,55,0.6),0_20px_60px_-15px_rgba(212,175,55,0.6)]"
              >
                <Zap size={16} strokeWidth={2} />
                Solicitar Análise Agora
                <ArrowUpRight
                  size={16}
                  strokeWidth={2}
                  className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
                />
              </a>
              <div className="flex flex-col text-xs text-[#A3ABB8] tracking-[0.12em] uppercase">
                <span>Resposta em até 48h</span>
                <span className="text-[#D4AF37] mt-1">100% confidencial</span>
              </div>
            </div>
          </div>

          {/* Right — proof pillars */}
          <div className="lg:col-span-4">
            <div className="grid grid-cols-2 gap-px bg-[#D4AF37]/15 border border-[#D4AF37]/25">
              {[
                { k: "48h", v: "Análise" },
                { k: "100%", v: "Sigilo" },
                { k: "+R$ 50MM", v: "Operados" },
                { k: "0", v: "Burocracia" },
              ].map((s, i) => (
                <div
                  key={i}
                  data-testid={`form-banner-stat-${i}`}
                  className="bg-[#05070D]/85 backdrop-blur py-8 px-5 text-center"
                >
                  <div className="font-serif-ag text-[#D4AF37] text-3xl md:text-4xl font-light leading-none">
                    {s.k}
                  </div>
                  <div className="mt-2 text-[10px] uppercase tracking-[0.22em] text-[#A3ABB8]">
                    {s.v}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
